<div class="h-52 md:h-72 container mx-auto w-full bg-cover bg-center flex flex-col justify-center items-center gap-2"
  style="background-image: url('../../../assets/images/leadership/leadership-banner.png');">
  <span class="font-medium text-white text-2xl md:text-3xl">Careers&#64;Varroc Connect</span>
  <span class="font-light text-white text-xl md:text-2xl px-5">Join Our Team</span>
</div>

<div class="flex flex-col items-center justify-center gap-5 mt-12">
  <span class="px-5 text-2xl md:text-3xl text-black font-light text-center w-full md:w-3/5">
    Diverse culture where curious minds collaborate
  </span>
</div>

<div class="w-full flex flex-col items-center justify-center gap-8 mt-10">
  <!-- Job Details -->
  <div class="flex items-start justify-start px-5 w-5/6 md:w-3/4 gap-5">
    <div class="flex flex-col items-start justify-start gap-4 mt-4">
      <h3 class="text-xl font-bold"> Lead/Manager-MobileApp Development</h3>
      <div class="flex gap-3 items-center">
        <img src="../../../../assets/images/careers/experience.png" alt="Experience Icon" class="size-5">
        <p class="text-black text-sm">10+ years</p>
      </div>
      <div class="flex gap-3 items-center">
        <img src="../../../../assets/images/careers/job-location.png" alt="Location Icon" class="size-5">
        <p class="text-black text-sm">Pune, India</p>
      </div>
      <div class="flex gap-3 items-center">
        <img src="../../../../assets/images/careers/employment-type.png" alt="Employment Type Icon" class="size-5">
        <p class="text-black text-sm">Full Time</p>
      </div>
    </div>
  </div>

  <!-- Position Overview -->
  <div class="flex flex-col items-start justify-start px-5 w-5/6 md:w-3/4 gap-5">
    <span class="font-bold">Position Overview</span>
    <p class="text-sm">
      We are seeking a highly skilled and motivated Lead/Manager-MobileApp Development to oversee the development and 
      management of our mobile applications. This role involves leading a team of developers, collaborating with 
      cross-functional teams, and driving technical excellence to deliver high-quality mobile solutions that align 
      with our strategic objectives.
    </p>
  </div>

  <!-- Roles and Responsibilities -->
  <div class="flex flex-col items-start justify-start px-5 w-5/6 md:w-3/4 gap-5">
    <span class="font-bold">Roles and Responsibilities</span>
    <ul class="list-disc list-inside text-lg">
      <li class="mb-2 text-sm" *ngFor="let role of roles">
        {{role}}
      </li>
    </ul>
  </div>

  <!-- Qualification -->
  <div class="flex flex-col items-start justify-start px-5 w-5/6 md:w-3/4 gap-5">
    <span class="font-bold">Qualification</span>
    <ul class="list-disc list-inside text-lg">
      <li class="mb-2 text-sm">
        Bachelor’s degree in Computer Science, Engineering, or a related field.
      </li>
      <li class="mb-2 text-sm">
        Proven experience (10+ years) in mobile app development, with at least 2 years in a leadership or managerial role.
      </li>
    </ul>
  </div>

  <!-- Skills Required -->
  <div class="flex flex-col items-start justify-start px-5 w-5/6 md:w-3/4 gap-5">
    <span class="font-bold">Skills Required</span>
    <ul class="list-disc list-inside text-lg">
      <li class="mb-2 text-sm" *ngFor="let skill of skills">
        {{skill}}
      </li>
    </ul>
  </div>

  <!-- About Us -->
  <div class="flex flex-col items-start justify-start px-5 w-5/6 md:w-3/4 gap-5">
    <span class="font-bold">About Us</span>
    <p class="text-sm">
      Varroc Connect is at the forefront of technology-driven innovation in the automotive industry. We focus on 
      creating advanced connected vehicle solutions that enhance user experience, safety, and efficiency. Join us 
      in shaping the future of mobility.
    </p>
  </div>

  <!-- Career Form Submission -->
  <app-career-form-submission class="px-5 w-5/6 md:w-3/4" [jobDescription]="selectedJob"></app-career-form-submission>
</div>